<template>
  <div>
    <!-- titre / sous-titre-->
    <app-heading
            :mainTitle="title"
            :subTitle="subtitle"
            ></app-heading>
    <!-- contenu dynamique -->
    <div class="minibasket__link-area">
      <div class="minibasket__link-box" v-for="item in requestLinks" :key="item.id">
        <app-linker
        htmlBefore="<i class='fas fa-chevron-right link-box__icon'></i> "
        :link="item.acf"
        classData="link-box__link"
        >
        </app-linker>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeading from "./AppHeading.vue";
import DynamicLinker from "./DynamicLinker.vue";

import axios from 'axios';
import {_} from 'underscore';

import RestApiHelper from "../../../helpers/rest-api-func.js";
import { RestPageIdx, RestCustomPosts, WP_API_ACF_ROOT_URL, WP_API_WP_ROOT_URL } from '../../../helpers/rest-api-addr.js';


export default {
  data() {
    return {
      requestLinks: [],
      isLoadingData: false
    }
  },
  props: {
    title: {
      type: String,
      default: "Voir aussi"
    },
    subtitle: {
      type : String,
      default: "Liens utiles"
    },
    linkIds : {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  mounted() {
    this.debouncedLoad = _.debounce(this.loadLinks, 500, true);
    this.loadLinks();
  },
  watch: {
    linkIds: function(newIds, oldIds) {
        this.linkIds = newIds;
        this.debouncedLoad();
    }
  },
  methods: {
    loadLinks() {
      if(this.linkIds && this.linkIds.length > 0) {
        this.isLoadingData = true;
        // requete de nouveaux liens.
        RestApiHelper.requestCustomPostData(
                WP_API_WP_ROOT_URL,
                RestCustomPosts.liens.rest_name,
                this.linkIds)
        .then(r_data => {
          this.setData(r_data.data, false);
        })
        .catch(error => {
          this.setData(null, false);
        })
      } else {
        this.requestLinks = [];
      }
    },
    setData(data, isLoading) {
      this.requestLinks = data ? data : [];
      this.$nextTick(function() {
        this.isLoadingData = isLoading;
      });
    }
  },
  components: {
    "app-heading": AppHeading,
    "app-linker": DynamicLinker
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/shared/RelatedLinkSection.vue